import { RpiTable } from "../../rpi-core/table/RpiTable";
import { GraphQL, GraphQLPagedQueryData } from "@rpi/openapi-api";
import { orderColumns } from "../../configuration/columns/orders.column";
import { RpiTableContainer } from "../../components/RpiTableContainer";
import React from "react";
import { RpiTableSortByProviderProps } from "../../rpi-core/table/modules/RpiTableSortBy";

type OrdersType = GraphQLPagedQueryData<GraphQL.OrdersQuery>;

export interface OrdersTableProps {
  orders?: OrdersType[];
  isLoading: boolean;
  error?: unknown;
  withSortBy?: Omit<RpiTableSortByProviderProps, "children"> | undefined;
  footer?: React.ReactNode;
}

export function OrdersTable({ orders, isLoading, error, withSortBy, footer }: OrdersTableProps) {
  return (
    <RpiTableContainer data-testid="orders-table" aria-label="Orders table" footer={footer}>
      <RpiTable
        withSortBy={withSortBy}
        emptyMessage={"No orders found."}
        isLoading={isLoading}
        error={error}
        perPage={orders?.length}
        data={orders}
        columns={orderColumns}
      />
    </RpiTableContainer>
  );
}
